/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3dvcmxkLXJhbmtpbmctc3RhdGlzdGljcy93b3JsZC1yZWNvcmRzL2NvbXBvbmVudHMvYm9vdHN0cmFwLXdvcmxkLXJlY29yZHMvYm9vdHN0cmFwLXdvcmxkLXJlY29yZHMuY29tcG9uZW50LnNjc3MifQ== */"];
export { styles as styles };
